import Icon from './Icon';
import List from './List';
import Show from './Show';
import appRoles from '../../util/roles';

const roles = [
    appRoles.ClubAdmin,
    appRoles.DistrictAdmin,
    appRoles.MultiDistrictAdmin,
    appRoles.SysAdmin,
];

const name = 'trainings';

export default { name, roles, Icon, List, Show };